/*
 * @Author: DT
 * @Date: 2022-10-19 09:38:52
 * @LastEditors: DT
 * @LastEditTime: 2022-11-09 19:10:27
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/returnGoods/orderList/orderList.js
 */
import { returnTakeDetailApi } from "@/libs/api";
export default {
  data() {
    return {
      listStatus: 1,
      listData: [],
    };
  },
  mounted() {
    console.log("id=======", this.$route.query.id);
    window.dsBridge &&
      window.dsBridge.call("setNativeTitle", {
        title: "",
      });
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    this.getList(this.$route.query.id);
  },
  methods: {
    getList(id) {
      returnTakeDetailApi({ id })
        .then((res) => {
          if (res.returnCode == "0000") {
            if (res.result) {
              this.listData = res.result.list;
              if (this.listData.length > 0) {
                this.listStatus = 2;
                this.listData.forEach((ele) => {
                  ele.itemId = ele.itemId.split(",");
                  ele.itemName = ele.itemName.split(",");
                  ele.productPic = ele.productPic.split(",");
                  ele.productPic.forEach((item, index) => {
                    if (ele.productPic[index].indexOf("|*|") > -1) {
                      console.log("有");
                      ele.productPic[index] = ele.productPic[index].split(
                        "|*|"
                      )[0];
                    }
                  });
                  ele.returnDriverNum = ele.returnDriverNum.split(",");
                });
              }
            } else {
              this.listStatus = 3;
            }
          } else {
            this.listStatus = 3;
          }
          this.$toast.clear();
        })
        .catch(() => {
          this.listStatus = 3;
        });
    },
  },
};
